import { render, staticRenderFns } from "./ImportUsers.vue?vue&type=template&id=f71068c8&scoped=true&"
import script from "./ImportUsers.vue?vue&type=script&lang=js&"
export * from "./ImportUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71068c8",
  null
  
)

export default component.exports